const constructIssueNameTextValue = (value, issue) => {
  let prefix = issue.display_name.split("/")[0];
  prefix = prefix.trim();
  const testValue = value.split("/")[0];
  return prefix === testValue ? value : `${prefix} / ${value}`;
};

export default constructIssueNameTextValue;
